import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { NewsType, useGetNews } from "../lib/services";
import { titles } from "../store/title.atome";
import BreadCrumb from "./BreadCrumb";
import Content from "./Content";
import Controls from "./Controls";
import Header from "./Header";

const AppContainer = () => {
  const getNews = useGetNews();
  const [, setNewsTitles] = useRecoilState(titles);

  useEffect(() => {
    getNews
      .then((res) => {
        const data = res.data as NewsType;
        setNewsTitles(data.data);
      })
      .catch((err) => {
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-dvh max-h-dvh flex-col overflow-y-hidden">
      <Header />
      <BreadCrumb />
      <Content />
      <div className="relative z-[1500] justify-self-end border-t-[1px] border-t-rss-border bg-white p-5 md:hidden">
        <Controls />
      </div>
    </div>
  );
};

export default AppContainer;
